// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"ed28dcf3","152":"4facb567","184":"6b798439","383":"1a2186ef","403":"3ed4370c","422":"26b277ca","427":"62978a1e","488":"ec6eec6c","704":"ae23d40d","720":"b7a124b5","757":"96791987","823":"4e14714d","916":"32cec077","977":"b0b80c5b"}[chunkId] + ".chunk.js";
};